module.exports = __webpack_public_path__ + "img/empowerment.1ac6a319.png";